/**
 * Shared currency formatting. Money is stored in paise everywhere in this
 * codebase; render it through these helpers only — never re-implement the
 * divide-by-100 + symbol logic inside a page.
 */
const INR = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

/** Formats an integer paise amount as Indian rupees, e.g. 26000 -> "₹260". */
export function formatPaise(paise: number | null | undefined): string {
  if (paise === null || paise === undefined || !Number.isFinite(Number(paise))) return "—";
  return INR.format(Number(paise) / 100);
}